/* eslint-disable no-unused-vars */
// **  cognito helper
import { CognitoAuth } from "@contexts/auth/cognito"

// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

import { userRoles } from "@constants/system"
// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

/** initla state for auth store  */
const initialState = {
  data: [],
  current: {},
  reserved_nicknames: [],
  currentPage: 1,
  countQatarCustomer: 0,
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 50,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const customers = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    setReservedNicknames: (s, payload) => {
      return {
        ...s,
        reserved_nicknames: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCountQatar: (s, payload) => {
      return {
        ...s,
        countQatarCustomer: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceRecord: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.status = payload.status

      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceUpdated: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.name = payload.name
      item.qid = payload.qid

      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    // currentPage
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.customers],
        (customers, customersLoading) => {
          return customersLoading.error || ""
        }
      )
    },
    /**
     *
     * @returns
     */
    reservedNicknames() {
      return createSelector([slice], (customers) => customers.reserved_nicknames)
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.customers],
        (customers, customersLoading) => customersLoading.success
      )
    },
    /**
     *
     * @returns
     */
    paginationData() {
      return createSelector([slice], (customers) => {
        let _data = customers.data || []
        
        // Safety check - ensure data is an array
        if (!Array.isArray(_data)) {
          return []
        }
        
        // Sort data from latest to oldest by createdAt field
        _data = [..._data].sort((a, b) => {
          const dateA = new Date(a.createdAt || 0)
          const dateB = new Date(b.createdAt || 0)
          return dateB - dateA // Latest first (descending order)
        })
        
        if (!isEmpty(customers.filters)) {
          const status = customers.filters.status

          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status === status.value)
              : _data
            : _data
        }
        if (!!customers.keyword) {
          const options = {
            keys: ["name", "phone", "email", "qid"]
          }
          const fuse = new Fuse(_data, options)
          _data = fuse.search(customers.keyword)
          _data = _data.map((e) => e.item)
        }

        const offset = (customers.currentPage - 1) * customers.itemPerPage
        _data = drop(_data, offset).slice(0, customers.itemPerPage)
        return _data
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchCustomers() {
      appLogger.info("fetchCustomers", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.FETCH_CUSTOMERS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          "/accounts/v1/"
        )

        // Handle different response formats
        let data = result
        if (result && typeof result === 'object' && result.items) {
          data = result.items
        } else if (result && typeof result === 'object' && result.data) {
          data = result.data
        }
        
        if (!Array.isArray(data)) {
          data = []
        }
        this.setData(data)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setData([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    async fetchReservedNicknames() {
      appLogger.info("fetchReservedNicknames", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.FETCH_RESERVED_NICKNAMES)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setReservedNicknames([])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          "/accounts/v1/nickname"
        )

        this.setReservedNicknames(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setReservedNicknames([])
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    async saveReservedNicknames(payload) {
      appLogger.info("saveReservedNicknames", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.SAVE_RESERVED_NICKNAMES)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setReservedNicknames(Array.isArray(payload) ? payload : [])
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.post(
          "adminsApi",
          "/accounts/v1/nickname",
          {
            body:payload
          }
        )

        this.setReservedNicknames(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    /**
     * Get stuff by PK
     *
     * @param {*} id
     */
    async getCustomerAccount(id) {
      appLogger.info("getCustomerAccount", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.GET_CUSTOMER)
      if (shouldSkipProtectedDashboardCalls()) {
        const items = Array.isArray(this.data) ? this.data : []
        const row = items.find((x) => x.pk === id) || {}
        this.setCurrent(row)
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.get(
          "adminsApi",
          `/accounts/v1/${id}`
        )

        // Ensure result is not null/undefined before setting
        if (result) {
          this.setCurrent(result)
        } else {
          // Set empty object if result is null/undefined
          this.setCurrent({})
        }
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        // Set empty object on error to prevent null reference errors
        this.setCurrent({})
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    /**
     *
     * @param {*} term
     */
    async searchCustomerByCountry(term) {
      appLogger.info("searchCustomerByCountry", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.SEARCH_CUSTOMER_BY_COUNTRY)
      try {
        const result = await API.post(
          "customersApiGateway",
          `/customers/accounts/search/country`,
          {
            body: { term }
          }
        )
        if (term === "Qatar") {
          this.setCountQatar(result)
        }
      } catch (error) {
        throw new Error(error)
      }
    },

    
    /**
     *
     * @param {*} id
     */
    async verifyCustomer({ pk, createdAt }) {
      appLogger.info("verifyCustomer", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.VERIFY_CUSTOMER)
      if (shouldSkipProtectedDashboardCalls()) {
        this.replaceRecord({ pk, status: "VERIFIED" })
        this.setMessage("msg_customer_verified")
        this.setAction(globalConst.action.NONE)
        return
      }

      try {
        const result = await API.put(
          "customersApiGateway",
          `/customers/${pk}/verify`,
          {
            body: { createdAt }
          }
        )
        this.replaceRecord({ pk, status: "VERIFIED" })
        this.setMessage("msg_customer_verified")
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} payload
     */
    async activateCustomer({ pk }) {
      appLogger.info("verifyCustomer", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.ACTIVATE_CUSTOMER)
      if (shouldSkipProtectedDashboardCalls()) {
        this.replaceRecord({ pk, status: "ACTIVE" })
        this.setMessage("msg_customer_activated")
        this.setAction(globalConst.action.NONE)
        return
      }

      try {
                const result = await API.post(
          "adminsApi",
          `/accounts/v1/${pk}/activate`,{
            body:{}
          }
        )

        this.replaceRecord({ pk, status: "ACTIVE" })
        this.setMessage("msg_customer_activated")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} payload
     */
    async blockCustomer({ pk, createdAt, reason }) {
      appLogger.info("blockCustomer", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.BLOCK_CUSTOMER)
      if (shouldSkipProtectedDashboardCalls()) {
        this.replaceRecord({ pk, status: "BLOCKED" })
        this.setMessage("msg_customer_blocked")
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.put(
          "customersApiGateway",
          `/customers/${pk}/block`,
          {
            body: { createdAt, reason }
          }
        )
        this.replaceRecord({ pk, status: "BLOCKED" })
        this.setMessage("msg_customer_blocked")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },

    async updateAccount(payload) {
      appLogger.info("blockCustomer", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.UPDATE_CUSTOMER)
      if (shouldSkipProtectedDashboardCalls()) {
        this.replaceUpdated({ pk: payload.pk, qid: payload.qid, name: payload.name })
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        const result = await API.put(
          "customersApiGateway",
          `/customers/accounts`,
          {
            body: payload
          }
        )
        this.replaceUpdated({ pk: payload.pk, qid: payload.qid, name: payload.name })
        // this.setMessage("msg_customer_blocked")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     * @param {*} payload
     */
    async rejectCustomer({ pk, createdAt, reason }) {
      appLogger.info("rejectCustomer", `[REDUX][${STORES.CUSTOMERS}]`)
      this.setAction(globalConst.action.REJECT_CUSTOMER)
      if (shouldSkipProtectedDashboardCalls()) {
        this.replaceRecord({ pk, status: "REJECTED" })
        this.setMessage("msg_customer_rejectd")
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
        await API.post(
          "adminsApi",
          `/accounts/v1/${pk}/reject`,
          {
            body: { reason }
          }
        )
        this.replaceRecord({ pk, status: "REJECTED" })
        this.setMessage("msg_customer_rejectd")
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        this.setAction(globalConst.action.NONE)
        return
      }
    },
    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },

    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      
      this.setCurrentPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    }
  })
}
